<template>
  <v-card>
    <FufuHeader>
      確認画面
    </FufuHeader>

    <v-card-text>
      <v-layout justify-center>
        ご入力ありがとうございます。
      </v-layout>
      <v-layout justify-center>
        内容を確認し、問題がなければ確定ボタンを押してください。
      </v-layout>
    </v-card-text>

    <v-card-text>
      <NoticeCheck
        :patch-test.sync="form.patchTest"
        :notice-checks.sync="form.noticeChecks"
        hide-input
      />
    </v-card-text>

    <v-card-text>
      <h3 class="primary--text text-center my-5">ご記入内容</h3>
    </v-card-text>

    <v-card-text>
      <v-divider />
      <ConfirmInputData :questions="questions" :form="form" />
      <v-divider />
    </v-card-text>

    <v-layout class="my-6">
      <v-flex xs6 class="px-6">
        <v-btn
          color="secondary"
          x-large
          block
          :disabled="loading"
          @click="back"
        >
          <span class="subtitle-1">
            <b>修正する</b>
          </span>
        </v-btn>
      </v-flex>
      <v-flex xs6 class="px-6">
        <v-btn color="primary" x-large block :loading="loading" @click="submit">
          <span class="subtitle-1">
            <b>確定する</b>
          </span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import FufuHeader from '@/components/FufuHeader'
import NoticeCheck from '@/components/NoticeCheck'
import ConfirmInputData from '@/components/ConfirmInputData'

export default {
  name: 'ConfirmView',
  components: {
    FufuHeader,
    NoticeCheck,
    ConfirmInputData,
  },
  data: () => ({
    form: null,
    loading: false,
  }),
  computed: {
    ...mapGetters(['questions']),
  },
  created() {
    this.form = Object.assign({}, JSON.parse(this.$route.query.form))
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
  },
  methods: {
    back() {
      this.$router.replace({
        path: '/',
        query: { form: JSON.stringify(this.form) },
      })
    },
    async submit() {
      if (this.loading) return

      try {
        this.loading = true
        let user = this.$store.state.user
        let customerId = user.customer

        let data = null
        if (customerId)
          data = await this.$api.customers(customerId).update(this.form)
        else data = await this.$api.customers().create(this.form)
        this.$router.replace({
          path: '/done',
          query: { form: JSON.stringify(data) },
        })
      } catch (err) {
        this.$toast.error('サーバとの通信に失敗しました。')
        console.error(err)
        this.loading = false
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let form = Object.assign({}, JSON.parse(to.query.form))
      await store.dispatch('fetchQuestions')
      next(vm => {
        vm.form = form
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>
